import BaseTimePicker, {
  TimeRangePickerProps as BaseTimeRangePickerProps,
} from 'antd/lib/time-picker'
import locale from 'antd/lib/date-picker/locale/ja_JP'
import 'moment/locale/ja'

const { RangePicker: BaseRangePicker } = BaseTimePicker

export type TimeRangePickerProps = Omit<
  BaseTimeRangePickerProps,
  'locale' | 'showTime' | 'picker'
>

export const RangePicker = (props: TimeRangePickerProps): JSX.Element => (
  <>
    <BaseRangePicker
      locale={locale}
      format="HH:mm"
      minuteStep={10}
      {...props}
    />
  </>
)
